import { render, staticRenderFns } from "./TabAccordions.vue?vue&type=template&id=4078ce02"
import script from "./TabAccordions.vue?vue&type=script&lang=js"
export * from "./TabAccordions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports